import React from 'react';
import { colors } from '@styles/colors';

// Label reutilizable con estilo consistente
const Label = ({ children, style = {}, ...props }) => {
  return (
    <label
      style={{
        display: 'block',
        marginBottom: '0.8vh',
        fontFamily: 'Inter',
        fontWeight: '600',
        fontSize: '2vh',
        color: colors.gray600,
        ...style
      }}
      {...props}
    >
      {children}
    </label>
  );
};

export default Label;